export default "__VITE_ASSET__CY4S6cwn__"